import { createAction, props } from '@ngrx/store';
import {UUID} from '../../../shared/types/uuid.type';
import {Destination} from '../../../services/api/destinations/destination.model';

export const startDestination = createAction(
  '[StartDestination] Start Destination',
  props<{ id: UUID }>()
);

export const startDestinationSuccess = createAction(
  '[StartDestination] Start Destination Success',
  props<{ data: Destination }>()
);

export const startDestinationFailure = createAction(
  '[StartDestination] Start Destination Failure',
  props<{ error: any }>()
);

export const clearStartDestinationState = createAction(
  '[StartDestination] clear Start Destination State',
);
